<section id="news" class="gap-container">
  <app-display-large>{{ "NewsTitle" | translate }}</app-display-large>

  <ng-container *ngIf="!loadingNews; else loadingTemplate">
    <div class="content">
      <div class="search-container">
        <app-search-input
          theme="light"
          searchMode="manual"
          (onSearch)="onSearchSubmit($event)"
        ></app-search-input>
      </div>
      <div class="news-list">
        <div
          *ngFor="let item of news; let i = index"
          class="news-item"
          [class.full]="i === 0"
        >
          <card-news
            [news]="item"
            [isDark]="i === 0"
            (clickNews)="goToNews($event)"
          ></card-news>
        </div>
      </div>
      <div class="other-news">
        <app-more-news [otherNews]="otherNews"></app-more-news>
      </div>
    </div>
    <button class="see-all-sticky-btn" (click)="goToSearchResults()">
      {{ "Seeall" | translate }}
      <mat-icon>add</mat-icon>
    </button>
  </ng-container>

  <ng-template #loadingTemplate>
    <div class="loading">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  </ng-template>
</section>
